<div class="container-xl" [ngClass]="{'p-0':isChatbotView}">
    <div class="block-section p-0">
        <div [ngClass]="{'main-content content-section':!isChatbotView}">
            <h2 class="mb-4" *ngIf="!isChatbotView">Vergleichen Sie Ihre Angaben mit den Daten anderer Teilnehmer.</h2>
            <div class="single-view" *ngIf="isSingleView">
                <div class="single-view-dropdown">
                    <label>Ihre Indikation: </label>
                    <select class="form-control" [(ngModel)]="selectedIndication" (change)="onChangeIndication()">
                        <ng-container *ngFor="let option of indicationList">
                            <option [value]="option">{{option}}</option>
                        </ng-container>
                    </select>
                </div>
                <p>Zum Vergleich die Angaben von <strong>{{totalIndication}}</strong> Teilnehmern mit der selben Indikation</p>
                <p *ngIf="isChatbotView">Ziel dieser Untersuchung ist die Erfassung von Patient Reported Outcomes (PRO) bei der therapeutischen Anwendung von Cannabis unter besonderer Berücksichtigung der Behandlung einzelner Symptomen. <a [attr.href]="openPageUrl" [attr.target]="'_parent'">mehr erfahren</a> </p>
                <div class="treated-symptoms">Behandelte Symptome</div>
            </div>
            <div class="info-view">
                <div class="info-view-item empty" [ngClass]="{'single-view':isSingleView}">
                    <div class="info-view-box"></div>
                    <div class="info-view-name">Ihre Auswahl</div>
                </div>
                <div class="info-view-item filled">
                    <div class="info-view-box"></div>
                    <div class="info-view-name">% Nennung / Teilnehmer </div>
                </div>
            </div>
            <div *ngIf="isSingleView">
                <div class="chatbot-single-chart">
                    <ul *ngIf="singleViewData.length">
                        <li *ngFor="let data of singleViewData" [ngClass]="{'matched':data.matched}">
                            <div class="single-chart-name">{{data.name}}</div>
                            <div class="single-chart-value">
                                <span>{{data.value}}</span>
                                <span class="bgcolor" [ngStyle]="{'opacity':data.opacity}"></span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container-xl" *ngIf="showLoading">
    <div class="block-section p-0">
        <div class="main-content heatmap-content has-loader">
            <div class="absolute-loading">
                <div class="lds-ripple"><div></div><div></div></div>
            </div>
        </div>
    </div>
</div>
<div class="container-xl mw-100" *ngIf="!isSingleView">
    <div class="block-section p-0">
        <div class="main-content heatmap-content">
            <div id="chatbot-heatmap-chart" class="chatbot-heatmap-chart"></div>
            <div id="chatbot-tooltip" class="chatbot-tooltip">
                <div class="label">{{tooltipData.indication}}</div>
                <div class="label">{{tooltipData.symptom}}</div>
                <div class="count">{{tooltipData.percentage}}</div>
            </div>
        </div>
    </div>
</div>
<div class="container-xl" [ngClass]="{'p-0':isChatbotView}">
    <div class="block-section p-0">
        <div class="page-btn-block" [ngClass]="{'mw-100 pt-0':isChatbotView}">
            <div class="page-btn" (click)="openThePage()">
                <div class="page-btn-info">
                    <ng-container *ngIf="isSingleView">
                        <div>Symptommatrix aller Indikationen</div>
                        <span>Widescreen Ansicht empfohlen</span>
                    </ng-container>
                    <ng-container *ngIf="!isSingleView">
                        <div>Eigene Indikation anzeigen</div>
                        <span>Liste anzeigen</span>
                    </ng-container>
                </div>
                <div class="page-btn-icon">
                    <img src='/images/chatbot/Copeia-Play.svg' alt='Copeia-Play.svg' />
                </div>
            </div>
        </div>
    </div>
</div>
